import React from "react";
import logoF from "./FooterLogo.png";
import {
  Line,
  Container,
  Top,
  Bottom,
  BG,
  QuestionBlue,
  QuestionWhite,
  Text1,
  Text2,
  Logo,
  Li,
  Ul1,
  Ul2,
  A,
  Text4,
  Text3,
  NeededCont,
  Div,
  DivCont,
} from "./styles";

const Footer = () => {
  return (
    <BG>
      <Line />
      <Container>
        <Logo src={logoF} />
        <Top>
          <Ul1>
            <Text3>Консалтинг</Text3>

            <Li>
              <A href="/services/supportduringthejobsearchsupport">
                Пакетное сопровождение
              </A>
            </Li>
            <Li>
              <A href="/services/supportduringtheprobationaryperiod">
                Сопровождение испытательного срока
              </A>
            </Li>
            <Li>
              <A href="/services/cvready">Резюме под ключ</A>
            </Li>
            <Li>
              <A href="/services/vs">Месячная подписка на поиск вакансий</A>
            </Li>
            <Li>
              <A href="/services/careerconsulting">Карьерная консультация</A>
            </Li>
            <Li>
              <A href="/services/talkitout">Карьерная сессия «Выговориться»</A>
            </Li>
          </Ul1>

          <Ul2>
            <Text4>Компания</Text4>
            <DivCont>
              <Div>
                <Li>
                  <A href="/about/company">О нас</A>
                </Li>
                <Li>
                  <A href="/about/blog">Блог</A>
                </Li>
                <Li>
                  <A href="https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/">
                    LinkedIn
                  </A>
                </Li>
              </Div>
              <Div>
                <Li>
                  <A href="https://t.me/+l1tXIWXd1RcwMDAy">Telegram</A>
                </Li>
                <Li>
                  <A href="https://instagram.com/belaymamba_it?igshid=YmMyMTA2M2Y=">
                    Instagram
                  </A>
                </Li>
                <Li>
                  <A href="https://youtube.com">YouTube</A>
                </Li>
              </Div>
            </DivCont>

            <NeededCont>
              <Li>
                <A href="/about">О нас</A>
              </Li>
              <Li>
                <A href="/blog">Блог</A>
              </Li>
              <Li>
                <A href="https://www.linkedin.com/in/%D0%BB%D1%8E%D0%B1%D0%BE%D0%B2%D1%8C-%D0%BF%D1%80%D0%BE%D1%85%D0%BE%D1%80%D0%BE%D0%B2%D0%B0-755167185/">
                  LinkedIn
                </A>
              </Li>

              <Li>
                <A href="https://t.me/+l1tXIWXd1RcwMDAy">Telegram</A>
              </Li>
              <Li>
                <A href="https://instagram.com/belaymamba_it?igshid=YmMyMTA2M2Y=">
                  Instagram
                </A>
              </Li>
              <Li>
                <A href="https://youtube.com">YouTube</A>
              </Li>
            </NeededCont>
          </Ul2>
        </Top>
        <Bottom>
          <QuestionBlue href="https://t.me/ProhorovaConsult">
            Задать вопрос
          </QuestionBlue>
          <QuestionWhite href="https://t.me/belaymamba_vacancy">
            Чат с вакансиями в Telegram
          </QuestionWhite>
          <Text1 href="/policy">Политика конфиденциальности</Text1>
          <Text2>Copyright © ProhorovaConsult</Text2>
        </Bottom>
      </Container>
    </BG>
  );
};
export default Footer;
